<template>
  <div class="menu-btn" @click="clicked" >
    <div class="menu-btn-icon-container" >
      <!-- Port / Harbour -->
      <span v-if="id === 'harbour'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.367"
          height="18.838"
          viewBox="0 0 37.367 18.838"
        >
          <g
            id="Insel_Icon"
            data-name="Insel Icon"
            transform="translate(41.867 813.007) rotate(180)"
          >
            <g
              id="Gruppe_12"
              data-name="Gruppe 12"
              transform="translate(16.256 801.008)"
              opacity="0.25"
            >
              <path
                id="Pfad_39"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_13"
              data-name="Gruppe 13"
              transform="translate(4.5 794.169)"
            >
              <path
                id="Pfad_39-2"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-2"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_14"
              data-name="Gruppe 14"
              transform="translate(28.012 794.169)"
              opacity="0.25"
            >
              <path
                id="Pfad_39-3"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-3"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      </span>
      <!--  Quay -->
      <span v-if="id === 'quay'">
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.367"
          height="18.838"
          viewBox="0 0 37.367 18.838"
        >
          <g
            id="Insel_Icon"
            data-name="Insel Icon"
            transform="translate(41.867 813.007) rotate(180)"
          >
            <g
              id="Gruppe_12"
              data-name="Gruppe 12"
              transform="translate(16.256 801.008)"
              opacity="1"
            >
              <path
                id="Pfad_39"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_13"
              data-name="Gruppe 13"
              transform="translate(4.5 794.169)"
              opacity="0.25"
            >
              <path
                id="Pfad_39-2"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-2"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_14"
              data-name="Gruppe 14"
              transform="translate(28.012 794.169)"
              opacity="0.25"
            >
              <path
                id="Pfad_39-3"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-3"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
        
      </span>
      <!--  Sea -->
      <span v-if="id === 'sea'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.367"
          height="18.838"
          viewBox="0 0 37.367 18.838"
        >
          <g
            id="Insel_Icon"
            data-name="Insel Icon"
            transform="translate(41.867 813.007) rotate(180)"
          >
            <g
              id="Gruppe_12"
              data-name="Gruppe 12"
              transform="translate(16.256 801.008)"
              opacity="0.25"
            >
              <path
                id="Pfad_39"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_13"
              data-name="Gruppe 13"
              transform="translate(4.5 794.169)"
              opacity="0.25"
            >
              <path
                id="Pfad_39-2"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-2"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_14"
              data-name="Gruppe 14"
              transform="translate(28.012 794.169)"
            >
              <path
                id="Pfad_39-3"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-3"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      </span>
      <!--  Overview -->
      <span v-if="id === 'overview'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.367"
          height="18.838"
          viewBox="0 0 37.367 18.838"
        >
          <g
            id="Insel_Icon"
            data-name="Insel Icon"
            transform="translate(41.867 813.007) rotate(180)"
          >
            <g
              id="Gruppe_12"
              data-name="Gruppe 12"
              transform="translate(16.256 801.008)"
              opacity="1"
            >
              <path
                id="Pfad_39"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_13"
              data-name="Gruppe 13"
              transform="translate(4.5 794.169)"
            >
              <path
                id="Pfad_39-2"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-2"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
            <g
              id="Gruppe_14"
              data-name="Gruppe 14"
              transform="translate(28.012 794.169)"
              opacity="1"
            >
              <path
                id="Pfad_39-3"
                data-name="Pfad 39"
                d="M4,.5.578,6.43,4,12.361h6.847l3.424-5.93L10.849.5Z"
                transform="translate(-0.498 -0.431)"
                fill="#fff"
              />
              <path
                id="Pfad_40-3"
                data-name="Pfad 40"
                d="M.16,6,3.544.139h6.768L13.7,6,10.311,11.86H3.544Zm3.3-6L0,6l3.464,6h6.927l3.464-6L10.391,0Z"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      </span>
    </div>
    <div class="menu-text" :class="activated?'menu-btn-active':''">{{ text }}</div>

    <div class="arrow-container" :class="activated?'menu-btn-active':''">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35.802"
        height="22.05"
        viewBox="0 0 35.802 22.05"
      >
        <path
          id="Vereinigungsmenge_1"
          data-name="Vereinigungsmenge 1"
          d="M1321.221-780.219l6.453-6.454H1299v-3.2h28.675l-6.454-6.454,2.264-2.263,10.318,10.318h0l-10.318,10.318Z"
          transform="translate(-1298.5 799.299)"
          stroke-miterlimit="10"
          stroke-width="1"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuButton",
  emits: ["btnclicked"],
  props: {
    id: String,
    text: String,
    activated:Boolean
  },
  data: () => {
    return {};
  },
  methods: {
    clicked() {
      this.$emit("btnclicked", this.id);
    },
  },
};
</script>

<style>
.menu-btn {
  color: var(--menu-btn-main-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  border-color: var(--menu-btn-main-color);
  border-style: solid;
  border-width: var(--menu-btn-border);
  user-select: none;
  cursor: pointer;
  color: var(--primary-font-color);
  font-family: var(--menu-btn-font);
  font-size: var(--menu-btn-font-size);
  width: var(--menu-btn-width);
  padding: var(--menu-btn-padding);
}
.menu-btn-icon-container {
  width: var(--menu-btn-icon-container-width);
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.arrow-container {
  align-self: flex-end;
  margin-left: auto;
  margin-right: var(--menu-btn-margin-right);
  stroke: #fff;
    fill: #fff;
}
.menu-text {
  margin-left: var(--menu-btn-text-margin-left);
}
.menu-btn-active{
    color: var(--hexagon-turquoise);
    stroke: var(--hexagon-turquoise);
    fill: var(--hexagon-turquoise);
}
</style>
